import { Component, Input, OnInit } from "@angular/core";
import { UploadedFile } from "../../app/app.models";
import { BrowserTab } from "@ionic-native/browser-tab";


@Component({
  selector: 'attachment',
  template: `
		<div>
    <a class="attachment" href="{{url}}" target="_blank" (click)="onClick($event)">
                  <span class="extension">{{file.extension}}</span>
                  <span class="filename">{{file.origFileName}}</span>
                </a>
  <ng-content></ng-content></div>`
})
export class Attachment implements OnInit {

  @Input() file: UploadedFile = null;
  
  private url: string;
  private browserTabAvailable: boolean = false;

  constructor(private browserTab: BrowserTab) {    
    this.browserTab.isAvailable().then(isAvailable => {
      this.browserTabAvailable = isAvailable;
    })
    
  }

  ngOnInit(): void {
    let uploadedFile = UploadedFile.createFromUploadedFileInfo(this.file);
    this.url = uploadedFile.url;
  }
  
  onClick(ev): void{    
    if(this.browserTabAvailable){
      ev.preventDefault();    
      this.browserTab.openUrl(this.url).catch((err)=>{
        console.error(err);
        window.open(this.url);
      });
    }        
  }

}


// WEBPACK FOOTER //
// ./src/partials/upload/attachment.ts